import { Validation } from "constants/Validation";
import * as Yup from "yup";

export const ResetPasswordSchema = Yup.object({
    userName: Yup.string().required("Please enter user name").matches(Validation.userName.regex, Validation.userName.message),
    password: Yup.string().required('Please enter your password').matches(Validation.password.regex, Validation.password.message)
    
})
